/* This renders an entire article on our website 

   Hassaan Ali Wattoo 
*/ 

import React from 'react';
import ReadArticleButton from './readArticleButton.jsx';

class Article extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            year: this.props.year, 
            headline: this.props.headline,
            authorName: this.props.authorName,
            authorPosition: this.props.authorPosition,
            logo: this.props.logo,
            isColor: this.props.isColor,
            theme: this.props.theme,
            image: this.props.image,
            articleText: this.props.articleText,
            subheadline: this.props.subheadline,
        }
    }

    componentDidMount(){
        window.scrollTo(0,0);
    }

    render() {

        const articleHeaderStyle = {
            backgroundImage: `linear-gradient(-180deg, rgba(0, 0, 0, 0.43) 0%, rgba(0, 0, 0, 0.33) 100%), url(${this.state.image})`  
        }

        const articleBackgroundStyle = {
            backgroundSize: `20px`
        }

        return (
            <div className="article">
                <div className="article-header" style={articleHeaderStyle}>
                    <div className="article-paper-logo container">
                        <div className="row">
                            <div className="article-home-button five columns filled">
                                <ReadArticleButton url={"/"} text={"Home Page"} theme={this.props.theme }/>
                            </div>
                            <div className="article-paper-logo seven columns">
                                <img src={this.state.logo} alt="Newspaper Logo" />
                            </div>
                        </div>
                    </div>

                </div>
                
                <div className="article-body container">
                    <div className="article-header-headline"> 
                        {this.state.headline} 
                    </div> 
                    <div className="article-header-author"> 
                        <strong>{this.state.authorName}</strong> {this.state.authorPosition} 
                    </div> 
                    <div className="article-header-text"> 
                        {this.state.articleText} 
                    </div> 
                    <div className="article-header-sub-headline"> 
                        {this.state.subheadline} 
                    </div> 
                </div>
            </div>
        );
    }
        
    
}




export default Article;